// Mock data para D-Lyrio

export const productos = [
  {
    id: 1,
    nombre: "Remera Slim",
    precio: 550,
    descripcion: "100% algodón, calidad premium",
    talles: ["S", "M", "L", "XL"],
    colores: ["Negro","Blanco", "Beige", "Uva", "Azul Piedra", "Otro"],
    material: "100% Algodón",
    categorias: ["remeras"],  // Ahora es array - puede tener múltiples
    imagenes: [
      "/images/productos/remera_slim_negro.png",
      "/images/productos/remera_slim_blanca.png",
      "/images/productos/remera_slim_beige.png",
      "/images/productos/remera_slim_uva.png",
      "/images/productos/remera_slim_azul_piedra.png"
    ]
  },
  {
    id: 2,
    nombre: "Remera Básica",
    precio: 490,
    descripcion: "Mezcla de poliéster y algodón",
    talles: ["S", "M", "L", "XL"],
    colores: ["Blanco", "Negro", "Azul Marino", "Verde Irlandes", "Otro"],
    material: "65% Poliéster, 35% Algodón",
    categorias: ["remeras"],
    imagenes: [
      "/images/productos/remera_basica_blanca.png",
      "/images/productos/remera_basica_negro.png",
      "/images/productos/remera_basica_azul_marino.png",
      "/images/productos/remera_basica_verde_irlandes.png",
    ]
  },
  {
    id: 3,
    nombre: "Short Slim Hombre",
    precio: 580,
    descripcion: "60% algodón, calidad premium",
    talles: ["S", "M", "L", "XL", "XXL"],
    colores: ["Negro", "Gris Melange", "Azul Marino"],
    material: "60% Algodón",
    categorias: ["shorts", "deportivo"],  // Múltiples categorías
    imagenes: [
      "/images/productos/short_slim_negro.png",
      "/images/productos/short_slim_gris_melange.png",
      "/images/productos/short_slim_azul_marino.png",
    ]
  },
  {
    id: 4,
    nombre: "Short Slim Mujer",
    precio: 550,
    descripcion: "60% algodón, calidad premium",
    talles: ["S", "M", "L", "XL", "XXL"],
    colores: ["Negro", "Gris Melange", "Beige"],
    material: "60% Algodón",
    categorias: ["shorts", "mujer"],
    imagenes: [
      "/images/productos/short_slim_negro_woman.png",
      "/images/productos/short_slim_gris_melange_woman.png",
      "/images/productos/short_slim_beige_woman.png"
    ]
  },
  {
    id: 5,
    nombre: "Oversize D-Lyrio",
    precio: 590,
    descripcion: "Estilo urbano oversize",
    talles: ["XS", "S", "M"],
    colores: ["Negro", "Blanco", "Beige"],
    material: "65% Poliéster, 35% Algodón",
    categorias: ["remeras"],
    imagenes: [
      "/images/productos/remera_over_negro.png",
      "/images/productos/remera_over_blanca.png",
      "/images/productos/remera_over_beige.png"
    ]
  },
  {
    id: 6,
    nombre: "Remera Woman",
    precio: 500,
    descripcion: "Diseño especial para mujer",
    talles: ["S", "M", "L", "XL"],
  colores: ["Beige", "Blanco"],
    material: "60% Algodón, 35% Poliéster, 5% Spandex",
    categorias: ["mujer", "remeras"],  // Múltiples categorías
    imagenes: [
      "/images/productos/remera_woman_beige.png",
      "/images/productos/remera_woman_blanca.png"
    ]
  },
  {
    id: 7,
    nombre: "Top Curt",
    precio: 450,
    descripcion: "Cómodo y versátil",
    talles: ["S", "M", "L", "XL"],
    colores: ["Negro", "Blanco", "Gris", "Otro"],
    material: "93% Algodón, 7% Elastano",
    categorias: ["mujer"],
    imagenes: [
      "/images/productos/top_curt_negro.png",
      "/images/productos/top_curt_blanco.png",
      "/images/productos/top_curt_gris.png"
    ]
  },
  {
    id: 8,
    nombre: "Musculosa Deport",
    precio: 250,
    descripcion: "Tejido Dry Fit para entrenamientos",
    talles: ["S", "M", "L", "XL"],
    colores: ["Blanco", "Negro", "Azul Marino"],
    material: "100% Poliéster Dry Fit",
    categorias: ["deportivo", "remeras"],  // Múltiples categorías
    imagenes: [
      "/images/productos/musculosa_deport_blanco.png",
      "/images/productos/musculosa_deport_negro.png",
      "/images/productos/musculosa_deport_azul_marino.png"
    ]
  },
  {
    id: 9,
    nombre: "Bandana 'Mi Mejor Amigo'",
    precio: 150,
    descripcion: "Personalizada para mascotas con su foto",
    talles: ["Único"],
    colores: ["Blanco"],
    material: "Tela de algodón",
    categorias: ["mascotas"],
    imagenes: [
      "/images/productos/bandana_1.png",
      "/images/productos/bandana_2.png"
    ]
  },
  {
    id: 10,
    nombre: "Bolso Yute Clásico",
    precio: 300,
    descripcion: "Ideal para llevar compras, artículos de playa o elementos de uso diario, con un toque rústico y elegante. DISEÑO PEQUEÑO",
    talles: ["Ancho: 41cm. Alto: 35cm. Profundidad: 15cm"],
    colores: ["Beige"],
    material: "Yute",
    categorias: ["otros"],
    imagenes: [
      "/images/productos/bolso_yute_comun.png"
    ]
  },
  {
    id: 11,
    nombre: "Bolso Yute Canva",
    precio: 350,
    descripcion: "Ideal para llevar lo necesario, con un toque personal y elegante. DISEÑO GRANDE",
    talles: ["Ancho: 41cm. Alto: 35cm. Profundidad: 15cm"],
    colores: ["Beige"],
    material: "Yute",
    categorias: ["otros"],
    imagenes: [
      "/images/productos/bolso_yute_canva.png"
    ]
  },
  {
    id: 12,
    nombre: "Bolso Yute Rayas",
    precio: 350,
    descripcion: "Bolso de yute en combinación con lienzo estampado a rayas. SIN DISEÑO",
    talles: ["Ancho: 41cm. Alto: 35cm. Profundidad: 15cm"],
    colores: ["Beige"],
    material: "Yute",
    categorias: ["otros"],
    imagenes: [
      "/images/productos/bolso_yute_rayas.png"
    ]
  }
];

export const categorias = [
  { id: "todos", nombre: "Todos los Productos" },
  { id: "remeras", nombre: "Remeras" },
  { id: "mujer", nombre: "Mujer" },
  { id: "shorts", nombre: "Shorts" },
  { id: "deportivo", nombre: "Deportivo" },
  { id: "mascotas", nombre: "Mascotas" },
  { id: "otros", nombre: "Otros" }
];

export const trabajosRealizados = [
  {
    id: 1,
    titulo: "Diseños Personalizados",
    descripcion: "Remeras con diseño exclusivo para cada cliente",
    imagenes: [
      "/images/trabajos/diseño_personalizado_1.png",
      "/images/trabajos/diseño_personalizado_2.png",
      "/images/trabajos/diseño_personalizado_3.png",
      "/images/trabajos/diseño_personalizado_4.png",
      "/images/trabajos/diseño_personalizado_5.png",
      "/images/trabajos/diseño_personalizado_6.png",
      "/images/trabajos/diseño_personalizado_7.png",
      "/images/trabajos/diseño_personalizado_8.png",
      "/images/trabajos/diseño_personalizado_9.png",
      "/images/trabajos/diseño_personalizado_10.png"
    ]
  },
  {
    id: 2,
    titulo: "Colección Baico",
    descripcion: "Diseño moderno y minimalista",
    imagenes: [
      "/images/trabajos/baico_1.png",
      "/images/trabajos/baico_2.png"
    ]
  },
  {
    id: 3,
    titulo: "Diseños Personalizados para Empresas / Negocios / Emprendimientos",
    descripcion: "Estampados elegantes con tu logo o diseño",
    imagenes: [
      "/images/trabajos/empresas_2.png",
      "/images/trabajos/empresas_1.png"
    ]
  },
  {
    id: 4,
    titulo: "Diseños Personalizados para Bolsos Yute",
    descripcion: "Bolsos de yute personalizados con diseños únicos",
    imagenes: [
      "images/trabajos/bolso_yute_1.png",
      "images/trabajos/bolso_yute_2.png",
      "images/trabajos/bolso_yute_3.png",
      "images/trabajos/bolso_yute_4.png"
    ]
  }
];

export const testimonios = [
  {
    id: 1,
    nombre: "María González",
    texto: "Excelente calidad y atención. Los diseños quedaron perfectos en las remeras para mi equipo.",
    rating: 5
  },
  {
    id: 2,
    nombre: "Carlos Rodríguez",
    texto: "Muy profesionales. La bandana personalizada de mi perro quedó increíble, super recomendados!",
    rating: 5
  },
  {
    id: 3,
    nombre: "Lucía Fernández",
    texto: "Los buzos personalizados para mi emprendimiento quedaron espectaculares. Entrega rápida.",
    rating: 5
  }
];

export const contactInfo = {
  whatsapp: "098 836 023",
  instagram: "@d_lyrioestampados",
  email: "dlyrioestampados@gmail.com",
  direccion: "San José de Mayo, San José, Uruguay",
  horario: "Lunes a Sábado de 9:00hs a 19:00hs"
};

export const sobreNosotros = {
  titulo: "Somos D-Lyrio",
  descripcion: "Somos una pareja joven con muchas ganas de crear algo único, especial y que nos represente. Nos gusta la música, viajar, los juegos de caja y los deportes.",
  servicios: [
    "Personalizamos en DTF (Direct to Film)",
    "Remeras • Buzos • Baby Tees • Uniformes • Tote Bags",
    "Colores vivos • Detalle fino • Durabilidad real"
  ],
  ventajasDTF: [
    "Se pega en algodón y mezclas",
    "No se cuartea fácilmente",
    "Ideal para diseños con muchos colores",
    "Tacto suave y duradero"
  ]
};
